export default {
    ERROR_CODE: "404",
    TITLE: "Страница не найдена.",
    DESCRIPTION: "Не удалось загрузить страницу"
};
